/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
    PaymentTypeToJSONTyped,
} from './PaymentType';
import type { Gender } from './Gender';
import {
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
    GenderToJSONTyped,
} from './Gender';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateUserRequest
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    cellPhone: string;
    /**
     * 
     * @type {Gender}
     * @memberof UpdateUserRequest
     */
    gender?: Gender | null;
    /**
     * 
     * @type {any}
     * @memberof UpdateUserRequest
     */
    dateOfBirth?: any | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    homePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    zip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    leadSource?: string | null;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof UpdateUserRequest
     */
    locationIds?: Array<ApiUserTasksGetPageParameter> | null;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof UpdateUserRequest
     */
    workLocationIds?: Array<ApiUserTasksGetPageParameter> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    payrollId?: string | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof UpdateUserRequest
     */
    payRate?: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {PaymentType}
     * @memberof UpdateUserRequest
     */
    paymentType?: PaymentType | null;
}



/**
 * Check if a given object implements the UpdateUserRequest interface.
 */
export function instanceOfUpdateUserRequest(value: object): value is UpdateUserRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    return true;
}

export function UpdateUserRequestFromJSON(json: any): UpdateUserRequest {
    return UpdateUserRequestFromJSONTyped(json, false);
}

export function UpdateUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'cellPhone': json['cellPhone'],
        'gender': json['gender'] == null ? undefined : GenderFromJSON(json['gender']),
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'homePhone': json['homePhone'] == null ? undefined : json['homePhone'],
        'address': json['address'] == null ? undefined : json['address'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'country': json['country'] == null ? undefined : json['country'],
        'leadSource': json['leadSource'] == null ? undefined : json['leadSource'],
        'locationIds': json['locationIds'] == null ? undefined : ((json['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'workLocationIds': json['workLocationIds'] == null ? undefined : ((json['workLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'payrollId': json['payrollId'] == null ? undefined : json['payrollId'],
        'payRate': json['payRate'] == null ? undefined : BalanceUnitStatementEntryDebitFromJSON(json['payRate']),
        'paymentType': json['paymentType'] == null ? undefined : PaymentTypeFromJSON(json['paymentType']),
    };
}

export function UpdateUserRequestToJSON(json: any): UpdateUserRequest {
    return UpdateUserRequestToJSONTyped(json, false);
}

export function UpdateUserRequestToJSONTyped(value?: UpdateUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'cellPhone': value['cellPhone'],
        'gender': GenderToJSON(value['gender']),
        'dateOfBirth': value['dateOfBirth'],
        'homePhone': value['homePhone'],
        'address': value['address'],
        'zip': value['zip'],
        'city': value['city'],
        'state': value['state'],
        'country': value['country'],
        'leadSource': value['leadSource'],
        'locationIds': value['locationIds'] == null ? undefined : ((value['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'workLocationIds': value['workLocationIds'] == null ? undefined : ((value['workLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'payrollId': value['payrollId'],
        'payRate': BalanceUnitStatementEntryDebitToJSON(value['payRate']),
        'paymentType': PaymentTypeToJSON(value['paymentType']),
    };
}

